module.exports = __webpack_public_path__ + "static/media/email.f57e6ef7.svg";